import { LogoImgOrigin } from '../../../Files/LogoImgOrigin.js';
import { GetYear } from '../Functions/GetDates.js';

export const BlockLogoOrigins = (props) => {
    const item = props.item;
    const strTotal = props.total.split('|');
    let val = [
        { name: item.oname, route: item.oroute, src: LogoImgOrigin('icon', item.otslug, item.oslug) },
        { number: item.onumber, name: item.otname, date: GetYear(item.ocreated) },
        { legend1: strTotal[0], legend2: strTotal[1] },
    ];
    return (
        <div className="logo">
            <a className="icon" href={val[0].route} alt={val[0].name} title={val[0].name}>
                <img className="img" src={val[0].src} title={val[0].name} alt={val[0].name} loading="lazy" />
            </a>
            <div className="legend">
                <div className="title">{val[0].name}</div>
                <div className="origintype">
                    <div className="number">{val[1].number}<sup>e</sup></div>
                    <div className="name">{val[1].name}</div>
                    <div className="date">{val[1].date}</div>
                </div>
                <div className="totals">
                    <div>{val[2].legend1}</div>
                    <div>{val[2].legend2}</div>
                </div>
            </div>
        </div>
    )

}